import { useInfiniteQuery } from "@tanstack/react-query";
import searchOrganizationProfiles from "../axios/searchOrganizationProfiles";

const useQuerySearchOrganizationProfiles = (searchTerm: string) => {
  return useInfiniteQuery(
    ["search_organisasi_internasional", searchTerm],
    ({ pageParam = 1 }) => {
      return searchOrganizationProfiles({
        search: searchTerm,
        page: pageParam,
      });
    },
    {
      enabled: Boolean(searchTerm.trim()),
      getNextPageParam: (lastPage, allPages) => {
        const organizationProfilesList = allPages.flatMap(
          (page) => page.organisasi_internasional.data,
        );
        if (
          organizationProfilesList.length <
          lastPage.organisasi_internasional.total
        ) {
          return lastPage.organisasi_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );
};

export default useQuerySearchOrganizationProfiles;
